import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface DesktopPanelTabsProps {
  tabs: string[];
  activeIndex: number;
  onChange: (index: number) => void;
}

export const DesktopPanelTabs: React.FC<DesktopPanelTabsProps> = ({ tabs, activeIndex, onChange }) => {
  return (
    <View style={styles.tabContainer}>
      {tabs.map((tab, index) => (
        <TouchableOpacity
          key={tab}
          style={[styles.tab, activeIndex === index && styles.activeTab]}
          onPress={() => onChange(index)}
          activeOpacity={0.7}
        >
          <Text style={[styles.tabText, activeIndex === index && styles.activeTabText]}>{tab}</Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  tabContainer: {
    backgroundColor: ADMIN_COLORS.SURFACE,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
    paddingVertical: 12,
    paddingHorizontal: 16,
    flexDirection: 'row',
    gap: 12,
  },
  tab: {
    flex: 1,
    paddingVertical: 8,
    borderRadius: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  activeTab: {
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
  },
  tabText: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT_SECONDARY,
  },
  activeTabText: {
    color: '#FFFFFF',
  },
});


